import {AllCategory} from "../index"

export function FetchAllCategoryFunc (page:number, limit:number, search:string, filter:string, sort:string){
    return AllCategory(page, limit, search, filter, sort)
}